const navigation = [
  { label: "Damen", category: "Damen", href: "/shop?category=Damen" },
  { label: "Herren", category: "Herren", href: "/shop?category=Herren" },
  { label: "Junior", category: "Junior", href: "/shop?category=Junior" },
  {
    label: "Wäsche",
    category: "Wäsche",
    href: "/shop?category=W%C3%A4sche",
  },
  { label: "Home", category: "Home", href: "/shop?category=Home" },
  {
    label: "Sale",
    category: "Sale",
    href: "/shop?category=Sale",
    accent: true,
  },
];

const social = [
  { label: "Instagram", href: "https://www.instagram.com/" },
  { label: "Facebook", href: "https://www.facebook.com" },
  { label: "Pinterest", href: "https://www.pinterest.de/" },
];

const siteConfig = {
  brandName: "Hecalvoro",
  logo: {
    src: "",
    text: "Hecalvoro",
    alt: "Hecalvoro",
    ariaLabel: "Hecalvoro Startseite",
  },
  description:
    "Zeitlose Naturmode und Heimtextilien aus hochwertigen Bio-Materialien – fair gefertigt und für ein langes Leben gemacht.",
  locale: "de-DE",
  currency: "EUR",
  freeShippingThreshold: 99,
  shippingFee: 4.95,
  cartPromotion: {
    code: "NATUR10",
    discountRate: 0.1,
  },
  contact: {
    heading: "Wir sind für dich da!",
    email: "transit@hecalvoro.cloud",
    address: "Marie-Curie-Straße 7, 35510 Butzbach, Deutschland",
    hours: "Montag bis Sonntag, 7:00–23:00 Uhr",
    serviceHours: "Montag bis Sonntag, 7:00–23:00 Uhr",
  },
  social,
  header: {
    promotion: {
      text: "SOMMERANGEBOT: ausgewählte Styles reduziert*",
      cta: "Jetzt entdecken",
      href: "/shop?category=Sale",
    },
    searchPlaceholder: "Best.-Nr. / Suchbegriff",
    searchLabel: "Produkte suchen",
    accountLabel: "Konto",
    wishlistLabel: "Merkliste",
    cartLabel: "Warenkorb",
    menuLabel: "Menü",
  },
  nav: navigation,
  navigation,
  trustBenefits: [
    {
      id: "secure",
      title: "Sicher einkaufen",
      text: "SSL-verschlüsselt & geschützt",
    },
    {
      id: "invoice",
      title: "Kauf auf Rechnung",
      text: "Flexibel und bequem bezahlen",
    },
    {
      id: "returns",
      title: "Einfache Retoure",
      text: "30 Tage Rückgaberecht",
    },
  ],
  newsletter: {
    eyebrow: "Trends & Styles",
    title: "Newsletter abonnieren & 20 € sichern",
    benefits: [
      "20 € Willkommensgutschein ab 99 € Bestellwert",
      "Exklusive Angebote und VIP-Aktionen",
      "Natürliche Inspiration statt Papierpost",
    ],
    placeholder: "Deine E-Mail-Adresse",
    buttonLabel: "Jetzt anmelden",
    consent:
      "Ich habe die Datenschutz-Information gelesen und stimme der Bestätigungs-E-Mail zu.",
    success: "Vielen Dank – bitte bestätige deine Anmeldung per E-Mail.",
  },
  footer: {
    serviceEyebrow: "Service & Beratung",
    serviceText:
      "Fragen zu Materialien, Passform oder Bestellung? Unser Beratungsteam hilft dir gern persönlich weiter.",
    contactLinkLabel: "Hilfe & Kontakt",
    columns: [
      {
        id: "service",
        title: "Service",
        links: [
          { label: "Hilfe & Kontakt", href: "/contact" },
          { label: "Versand & Lieferung", href: "/shipping" },
          { label: "Retoure", href: "/returns" },
          { label: "Datenschutz", href: "/privacy" },
          { label: "AGB", href: "/terms" },
        ],
      },
      {
        id: "brand",
        title: "Über uns",
        links: [{ label: "Unsere Haltung", href: "/about" }],
      },
      {
        id: "shopping",
        title: "Einkaufen",
        links: [
          { label: "Damen", href: "/shop?category=Damen" },
          { label: "Herren", href: "/shop?category=Herren" },
          { label: "Junior", href: "/shop?category=Junior" },
          { label: "Wäsche", href: "/shop?category=W%C3%A4sche" },
          { label: "Home", href: "/shop?category=Home" },
        ],
      },
    ],
    paymentTitle: "Bezahlarten",
    paymentMethods: ["Rechnung", "PayPal", "Mastercard", "VISA"],
    socialTitle: "Folge uns",
    locale: "Deutschland / de",
    copyrightName: "Hess Natur-Textilien GmbH",
  },
};

export { siteConfig };
export default siteConfig;
